"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _PromotionBanner = _interopRequireDefault(require("./PromotionBanner"));

var _LocalStorageKeys = require("../../constants/LocalStorageKeys");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIContactSalesButton = _interopRequireDefault(require("ui-addon-upgrades/button/UIContactSalesButton"));

var _Tracking = require("../../constants/Tracking");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _publicPageUrls = require("../../utils/publicPageUrls");

var _PurchaseMotionSelectors = require("../../selectors/PurchaseMotionSelectors");

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _getUsageTracker = _interopRequireDefault(require("../../utils/getUsageTracker"));

var _ProductOwnershipSelectors = require("../../selectors/ProductOwnershipSelectors");

var _colors = require("HubStyleTokens/colors");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          white-space: nowrap;\n          &&& {\n            color: ", ";\n            text-decoration: underline;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          &&& {\n            color: ", ";\n            text-decoration: underline;\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AuthedBodyText = function AuthedBodyText(_ref) {
  var isCustomer = _ref.isCustomer;
  var ttsType = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PurchaseMotionSelectors.talkToSalesTypeSelector)(state, _Hubs.default.HUB_MARKETING);
  });
  var contactIsc = ttsType === _PurchaseMotionTypes.TALK_TO_SALES_FALLBACK;
  var stringKey = isCustomer ? 'marketingContactsBeta.banner.existingUser.body_jsx' : 'marketingContactsBeta.banner.newUser.body_jsx';
  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: stringKey,
    elements: {
      Link: (0, _styledComponents.default)(_UIContactSalesButton.default).withConfig({
        displayName: "MarketingContactsBetaBanner__Link",
        componentId: "zkhbs1-0"
      })(_templateObject(), _colors.OBSIDIAN)
    },
    options: {
      use: 'link',
      contactIsc: contactIsc,
      upgradeData: {
        app: _Tracking.APP,
        screen: _Tracking.SCREENS.PRODUCTS_PLANS,
        upgradeProduct: _UpgradeProducts.MARKETING,
        uniqueId: 'marketing-contacts-banner'
      }
    }
  });
};

var PublicBodyText = function PublicBodyText() {
  var hubsSignupUrl = (0, _publicPageUrls.getHubsSignupUrl)({});
  var hubsSignupCta = (0, _publicPageUrls.getHubsSignupCTA)('tts', 'mc-banner', null, 'marketing-contacts');

  var onClick = function onClick() {
    return (0, _getUsageTracker.default)().track('externalLinkClick', {
      name: 'mc-banner'
    });
  };

  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: "marketingContactsBeta.banner.newUser.body_jsx",
    elements: {
      Link: (0, _styledComponents.default)(_UILink.default).withConfig({
        displayName: "MarketingContactsBetaBanner__Link",
        componentId: "zkhbs1-1"
      })(_templateObject2(), _colors.OBSIDIAN)
    },
    options: {
      external: true,
      href: (0, _publicPageUrls.getTtsUrl)() + "?hubs_signup-url=" + hubsSignupUrl + "&hubs_signup-cta=" + hubsSignupCta,
      onClick: onClick
    }
  });
};

var MarketingContactsBetaBanner = function MarketingContactsBetaBanner() {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isClosed = _useState2[0],
      setIsClosed = _useState2[1];

  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);
  var highestOwnedMarketingMerchId = (0, _reactRedux.useSelector)(function (state) {
    return (0, _ProductOwnershipSelectors.highestOwnedMerchIdInHubSelector)(state, _Hubs.default.HUB_MARKETING);
  });
  var ownsAnyMCMerch = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MarketingContactsSelectors.isMarketingContactsSKUSelector)(state, highestOwnedMarketingMerchId);
  });
  (0, _react.useEffect)(function () {
    // Existing MC users will see the banner on load, but it'll go away once product ownership data comes in
    // We set localStorage here so that happens once, then subsequent page visits will never flash the banner
    if (ownsAnyMCMerch) localStorage.setItem(_LocalStorageKeys.MC_BANNER_CLOSED, 'true');
  }, [ownsAnyMCMerch]);
  var shouldShow = isInMCBeta && !isClosed && !ownsAnyMCMerch && localStorage.getItem(_LocalStorageKeys.MC_BANNER_CLOSED) !== 'true';

  var onCloseClick = function onCloseClick() {
    localStorage.setItem(_LocalStorageKeys.MC_BANNER_CLOSED, 'true');
    setIsClosed(true);
  };

  var ownsMarketingProduct = highestOwnedMarketingMerchId && highestOwnedMarketingMerchId !== _HubMap.default[_Hubs.default.HUB_MARKETING].highlightedFreeMerch;
  return _react.default.createElement(_PromotionBanner.default, {
    className: "m-bottom-4",
    shouldShow: shouldShow,
    closeable: true,
    onClose: onCloseClick,
    promotion: "MC beta",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "marketingContactsBeta.banner.title"
    }),
    description: _react.default.createElement(_EnvironmentWrapper.default, {
      authedNode: _react.default.createElement(AuthedBodyText, {
        isCustomer: ownsMarketingProduct
      }),
      publicNode: _react.default.createElement(PublicBodyText, null)
    })
  });
};

var _default = MarketingContactsBetaBanner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/MarketingContactsBetaBanner.js
// module id = 851
// module chunks = 5 6